import React, { lazy, Fragment, useEffect } from 'react';
import { CustomRoute } from './Routing/CustomRoute';
import ItpTabs from './shared/components/ItpTabs';
import DeviceSelection from './ITP/DeviceSelection';
const LandingPage = lazy(() => import(/* webpackChunkName: "1.land" */"./shared/components/ITPLanding/components/index"));
const Itpdestination = lazy(() => import(/* webpackChunkName: "2.itpd" */"./shared/components/ITPDestination/index"));
const Traveldates = lazy(() => import("./ITP/TravelDates/components/index"));
const PlanSelection = lazy(() => import("./ITP/PlanSelection/components/index"));
const EffectiveDate = lazy(() => import("./ITP/EffectiveDate/components/index"));
const ReviewPage = lazy(() => import("./ITP/ReviewPage/components/index"));
const ConfimationPage = lazy(() => import("./ITP/Confirmation/components/index"));
const RemarksPage = lazy(()=> import("./ITP/Remarks/components/index"))
const ILDRemarksPage = lazy(()=> import("./ILD/ILDRemarks/components/index"))
const ILDDestination = lazy(() => import("./shared/components/ILDDestination/index"));
const ILDLineDeviceSelection = lazy(() => import("./ILD/ILDDeviceSelection/components/index"));
const ILDPlanSelection = lazy(() => import("./ILD/ILDDeviceSelection/components/planSelection"));
const countrylist = lazy(() => import("./ILD/ILDDeviceSelection/components/countryList"));
const ILDEffectiveDate = lazy(() => import("./ILD/EffectiveDate/components/index"));
const ILDFeatureConflict = lazy(() => import("./ILD/FeatureComparison/components/index"));
const ILDReviewPage = lazy(() => import("./ILD/ReviewPage/components/index"));
const ILDConfirmationPage = lazy(() => import("./ILD/Confirmation/components/index"));

const ILDLandingPage = lazy((/* webpackChunkName: "4.ildL" */) => import("./ILD/LandingPage/components/index"));
const RemovePlan = lazy(() => import(/* webpackChunkName: "3.rp" */"./RemovePlanPage/components/index"));
const globalRemovePlanEffectiveDate = lazy(() => import("./RemovePlanPage/components/globalRemovePlanEffectiveDate"));
const GlobalRemovePlanReview = lazy(() => import("./RemovePlanPage/components/globalRemovePlanReview"));
const globalRemovePlanConfirmation = lazy(() => import("./RemovePlanPage/components/globalRemovePlanConfirmation"));

const PendingOrder = lazy(() => import("./PendingOrder/components/index"));

const ForkPage = lazy(() => import("./ForkPage/components/index"));
const MVALandingPage =  lazy(() => import("./shared/components/LandingPage/components/index"));

import { isUnAuth } from "./shared/services/httpClient";
import common from "./shared/utilities/util";

const Routes = ({ reduxStore }) => {

  const routeConfig = (
    <div>
      { /* MVA Unauth*/ 
        (typeof (_isNative) !== "undefined" && _isNative && !isUnAuth()) ?
          <CustomRoute exact path="/" component={MVALandingPage} /> :
          (isUnAuth() || common.isACSS() || common.isPOS()) ?
            <CustomRoute exact path="/" component={Itpdestination} /> :
            <CustomRoute exact path="/" component={MVALandingPage} />
      }
      <CustomRoute path="/itplandingpage" component={MVALandingPage} />
      <CustomRoute path="/itpdestination" component={Itpdestination} />
      <CustomRoute path="/itptraveldates" component={Traveldates} />
      <CustomRoute path="/itpdeviceselection" component={DeviceSelection} />
      <CustomRoute path="/itpplanselection" component={PlanSelection} />
      <CustomRoute path="/itpeffectivedate" component={EffectiveDate} />
      <CustomRoute path="/itpreview" component={ReviewPage} />
      <CustomRoute path="/itpconfirmation" component={ConfimationPage} />
      <CustomRoute path="/itpremarks" component={RemarksPage} />
      <CustomRoute path="/ildremarks" component={ILDRemarksPage} />

      <CustomRoute path="/ildlandingpage" component={MVALandingPage} />
      <CustomRoute path="/ilddestination" component={ILDDestination} />
      <CustomRoute path="/ilddeviceselection" component={ILDLineDeviceSelection} />
      <CustomRoute exact path="/ildplans/:selectedIndex" component={ILDPlanSelection} />
      <CustomRoute exact path="/ildcountrylist/:selectedIndex" component={countrylist} />
      <CustomRoute path="/ildeffectivedate" component={ILDEffectiveDate} />
      <CustomRoute path="/ildfeaturecompare" component={ILDFeatureConflict} />
      <CustomRoute path="/ildreviewpage" component={ILDReviewPage} />
      <CustomRoute path="/ildconfirmation" component={ILDConfirmationPage} />

      <CustomRoute path="/removeplanpage" component={RemovePlan} />
      <CustomRoute path="/rpeffectivedate" component={globalRemovePlanEffectiveDate} />
      <CustomRoute path="/rpreview" component={GlobalRemovePlanReview} />
      <CustomRoute path="/rpconfirmation" component={globalRemovePlanConfirmation} />

      <CustomRoute path="/itpremoveplan" component={RemovePlan} />
      <CustomRoute path="/ildremoveplan" component={RemovePlan} />

      <CustomRoute path="/pendingorder" component={PendingOrder} />
      <CustomRoute path="/forkpage" component={ForkPage} />
      <CustomRoute path="/landingpage" component={MVALandingPage} />
    </div>
  );
  return (<Fragment>{routeConfig}</Fragment>);
}

export default Routes;
